var map = {
	"./items/action_&_adventure.png": 6946,
	"./items/biography.png": 4511,
	"./items/drama.png": 3109,
	"./items/fable.png": 4502,
	"./items/fantasy.png": 2030,
	"./items/fitness.png": 5052,
	"./items/graphic_novel.png": 7347,
	"./items/historical_fiction.png": 8839,
	"./items/horror.png": 5678,
	"./items/humor.png": 1169,
	"./items/literary_fiction.png": 5419,
	"./items/mystery.png": 6823,
	"./items/realistic_fiction.png": 6313,
	"./items/religion_spirituality.png": 53,
	"./items/romance.png": 2459,
	"./items/science_fiction.png": 8879,
	"./items/scifi_fantasy.png": 1203,
	"./items/short_story.png": 6852,
	"./items/theater.png": 2087,
	"./items/thriller__slash__suspense.png": 2861,
	"./modals/action_&_adventure.png": 2496,
	"./modals/biography.png": 3165,
	"./modals/drama.png": 4468,
	"./modals/fable.png": 5900,
	"./modals/fantasy.png": 8744,
	"./modals/fitness.png": 2290,
	"./modals/graphic_novel.png": 461,
	"./modals/historical_fiction.png": 5269,
	"./modals/horror.png": 4028,
	"./modals/humor.png": 2479,
	"./modals/literary_fiction.png": 3393,
	"./modals/mystery.png": 4053,
	"./modals/realistic_fiction.png": 6287,
	"./modals/religion_spirituality.png": 4791,
	"./modals/romance.png": 8321,
	"./modals/science_fiction.png": 2737,
	"./modals/scifi_fantasy.png": 7045,
	"./modals/short_story.png": 2598,
	"./modals/theater.png": 1025,
	"./modals/thriller__slash__suspense.png": 3379,
	"./origin": 6200,
	"./origin.json": 6200
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8629;